<script>
    import { Child } from 'pym.js';
    import Graphic from './Graphic.svelte';
    import meta from './data/meta.json';
    import pkg from '../package.json';
    import { onMount } from 'svelte';
    import manageParams from './utils/manageParams.js';
    import { setupViewportInview } from './utils/viewportInview.js';

    let pymChild = $state();
    let width = $state(600);
    let height = $state(0);
    let containerElement = $state();
    let trkEl;
    /** After first viewport math: enable .fade so opacity can transition (avoid invisible before pym runs). */
    let fadeClassArmed = $state(false);
    /** Current pym/IO inview (toggles with scroll). */
    let graphicInView = $state(false);
    /** Latches true once the graphic is considered in view — starts year animation once only. */
    let yearAnimationAllowed = $state(false);
    let manifestData = $state(null);
    let loadedData = $state(null);
    
    // Get forecast from query params (defaults to D1)
    const params = manageParams();
    const forecast = params.forecast;
    
    const manifestUrl = 'https://ix.cnn.io/data/snowfall/manifest_v2.json';
    
    function handlePymResize(newWidth) {
      width = newWidth;
    }
    
    function sendHeight() {
      if (pymChild) {
        pymChild.sendHeight();
      }
    }
    
    // Send map changes to parent window
    function handleMapChange(mapState) {
      if (pymChild) {
        pymChild.sendMessage('mapStateChange', JSON.stringify(mapState));
      }
    }
    
    
    // Fetch manifest data
    fetch(manifestUrl)
      .then(response => response.json())
      .then(data => {
        manifestData = data;
      })
      .catch(error => {
        console.error('Error fetching manifest:', error);
      });
    
    // Construct data URL based on manifest and forecast
    // const constructDataUrl = () => {
    //   if (!manifestData) return null;
    //   const availableForecasts = Object.keys(manifestData);
    //   if (availableForecasts.includes(forecast)) {
    //     return `https://ix.cnn.io/data/storms/${forecast}.geojson`;
    //   } else {
    //     return `https://ix.cnn.io/data/storms/D1.geojson`;
    //   }
    // }
    // const dataUrl = $derived(constructDataUrl());
    
    
    // Fetch forecast data when dataUrl changes
    // $effect(() => {
    //   if (dataUrl) {
    //     fetch(dataUrl)
    //       .then(response => response.json())
    //       .then(data => {
    //         loadedData = data;
    //       })
    //       .catch(error => {
    //         console.error('Error fetching forecast data:', error);
    //       });
    //   }
    // });
    
    // REACT TO HEIGHT CHANGES using $effect
    $effect(() => {
      if (pymChild && height > 0) {
        sendHeight();
      }
    });


    onMount(() => {
      pymChild = new Child({
        renderCallback: handlePymResize,
        id: pkg.name,
      });

      const cleanupViewport = setupViewportInview({
        pymChild,
        getTrackedElement: () => trkEl,
        threshold: 0.1,
        onState: ({ inview, fadeArmed }) => {
          if (fadeArmed) fadeClassArmed = true;
          graphicInView = inview;
          if (inview) yearAnimationAllowed = true;
        },
      });

      // Add app class to meta container if app param is true
      if (params.app === 'true') {
        document.querySelector('#meta')?.classList.add('app');
      }

      // Populate meta fields from meta.json
      Object.keys(meta).forEach((id) => {
        const node = document.querySelector(`.${id}`);
        if (node) {
          node.innerHTML = meta[id];
        }
      });

      if (containerElement) {
        const containerWidth = containerElement.clientWidth;
        if (containerWidth && containerWidth !== width) {
          width = containerWidth;
        }
      }

      return () => {
        cleanupViewport();
        if (pymChild) {
          pymChild.remove();
        }
      };
    });
  </script>
  
  <!-- BIND HEIGHT HERE -->
  <div bind:this={containerElement} bind:clientHeight={height} class="app-container" class:app={params.app === 'true'}>
    <div
      bind:this={trkEl}
      class="trk"
      class:fade={fadeClassArmed}
      class:inview={graphicInView}
    >
      <Graphic
        {width}
        {forecast}
        {manifestData}
        {loadedData}
        {params}
        yearAnimationAllowed={yearAnimationAllowed}
        onMapChange={handleMapChange}
      />
    </div>
  </div>

  <style>
    .app-container {
      width: 100%;
    }

    .app-container .trk.fade {
      opacity: 0;
      transition: opacity 0.5s ease-in-out;
    }

    .app-container .trk.fade.inview {
      opacity: 1;
    }
  </style>